import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Saphrtemplate extends Component {
 
  render() {
    const course =[
      {
        title : " Introduction to SAP and SAP HR",
        content: [
        "Introduction to SAP and its modules",
        "Overview of SAP HR (Human Resources)",
        "System Landscape - Three-tier Architecture",
        "SAP HR Sub-modules Overview",
        "System Navigation and Basic Concepts"
        ]
        },
        {
        title : " Organization Management (OM)",
        content: [
        "Introduction to Organizational Management",
        "Organizational Structures and Objects",
        "Relationships in OM",
        "Creation of Organizational Structure (Expert Mode and Simple Maintenance)",
        "Organizational and Staffing",
        "Info Types in OM",
        "Plan Version and Evaluation Path",
        "OM Reports"
        ]
        },
        {
        title : " Personnel Administration (PA)",
        content: [
        "Enterprise Structure and Assignment",
        "Personnel Structure and Assignment",
        "HR Master Data and Employee Attributes",
        "Info Types in PA",
        "Features and Info Type Ranges in HR",
        "Number Ranges for Employee Personnel Numbers",
        "Customizing User Procedures",
        "Personnel Actions - Info Group - Action Menu",
        "Dynamic Actions",
        "Payroll Area, Control Record, and Period Parameters",
        "Date Modifiers",
        "Payroll Period",
        "Pay Scale Structure, Area, Type, and Groups",
        "Employee Subgroup Grouping for CAP",
        "Integration with OM"
        ]
        },
        {
        title : " Time Management (TM)",
        content: [
        "Time Management Info Types",
        "Public Holidays and Holiday Calendar",
        "Factory and Work Schedules",
        "Break Schedules and Daily Work Schedules",
        "Period Work Schedules and Work Schedule Rules",
        "Absences and Attendances",
        "Absence and Attendance Quotas",
        "Time Evaluation and CATS (Cross-Application Time Sheet)",
        "Functions, Operations, PCR's (Personnel Calculation Rules), and Schemas in TM"
        ]
        },
        {
        title : " Payroll Management",
        content: [
        "Payroll Info Types",
        "Payroll Area, Control Record, and Period Parameters",
        "Date Modifiers",
        "Payroll Period",
        "Pay Scale Structure, Area, Type, and Groups",
        "Employee Subgroup Grouping for CAP",
        "Wage Types, Primary, Technical/Secondary, and Customer Wage Types",
        "Indirect Evaluation Mode",
        "Wage Type Characteristics and Models",
        "Payments and Deductions",
        "Garnishments and Factoring",
        "Off-Cycle Payroll",
        "Posting to Financial Accounting (Symbolic Accounts)"
        ]
        },
        {
        title : " Personnel Development (PD)",
        content: [
        "Planning and Setting up Qualifications Catalog",
        "Rating Scales and Appraisals",
        "Employee Appraisal and Appraisal Catalog"
        ]
        },
        {
        title : " Recruitment and Applicant Administration",
        content: [
        "Applicant Data and Applicant Selection",
        "Transferring Applicant Data to Personnel Administration"
        ]
        },
        {
        title : " Training & Event Management (TEM)",
        content: [
        "Training Requirements and Cost of Training",
        "Business Event Types and Employee Data for Business Event Type"
        ]
        },
        {
        title : " ABAP HR Concepts",
        content: [
        "Creation of Customer Info Types",
        "Info Type Menu Tab and Screen Modifications"
        ]
        },
        {
        title : " HR Reporting and Analytics",
        content: [
        "Generating HR Reports and Analytics using SAP HR Data"
        ]
        },
        {
        title : " Integration with Other SAP Modules",
        content: [
        "Integration with other SAP modules like FI (Financial Accounting), CO (Controlling), MM (Materials Management), etc."
        ]
        }
    ]

 
    const faqData = [
      {
        question: 'What is SAP HR training, and who should consider it? ',
        answer:
          'SAP HR training focuses on teaching individuals how to effectively manage human resources processes using SAP software. This training is ideal for HR professionals, IT professionals interested in HR systems, and individuals seeking career opportunities in HR management.',
      },
      {
        question: 'What topics are covered in SAP HR training? ',
        answer:
          'SAP HR training covers a wide range of topics including organizational management, personnel administration, time management, payroll processing, and reporting using SAP HR modules.',
      },
      {
        question: 'How long does SAP HR training typically last?',
        answer:
          'The duration of SAP HR training can vary depending on the training provider and the depth of the course. However, most programs offer comprehensive training that ranges from several weeks to a few months.',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          '"A person with SAP HR skills can pursue career opportunities as an SAP HR Consultant, HRIS Analyst, SAP HR Functional Analyst, HR Process Analyst, or HR Project Manager, working in HR departments of organizations or as consultants for SAP implementation projects.',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Are you considering a career in SAP HR? Look no further! Our training institute offers comprehensive SAP HR courses designed to equip you with the skills needed to excel in human resources management using SAP software. Our eligibility requirements are tailored to accommodate beginners and professionals alike. Whether you're new to SAP or seeking to enhance your HR management skills, our courses cater to individuals with diverse backgrounds and experiences. Joining our training program is your first step toward becoming proficient in SAP HR. Enroll now and unlock the door to rewarding career opportunities. Choose the best training center for SAP HR and embark on your journey to success today!"
      },

    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Saba Karim",
          date:" july 09 ,2023",
          review:` learnsoft.org offers comprehensive SAP HR training programs that are designed to provide a holistic understanding of SAP HR modules. Their courses are accessible online, allowing professionals to upskill while balancing their work commitments.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Eswar",
          date:" july 29 ,2023",
          review:"SAP HR training with certification from learnsoft.org is a stepping stone to a successful HR career. It equips HR professionals with the skills and knowledge they need to excel in the modern workplace."
      },
  ]

    return(
      <>
{/*         
          <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the contemporary landscape of organizational management, the effective utilization of human capital is paramount. SAP HR, interchangeably referred to as SAP Human Resources or SAP HCM (Human Capital Management), stands as a pivotal module within the SAP ERP (Enterprise Resource Planning) system. It assumes the mantle of overseeing every facet of human resource management within an organization. From personnel administration to talent management, SAP HR serves as the linchpin for efficient HR operations."/>
            */}
            
            <NewMainsec rating='4.0' students={"439"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the contemporary landscape of organizational management, the effective utilization of human capital is paramount. SAP HR, interchangeably referred to as SAP Human Resources or SAP HCM (Human Capital Management), stands as a pivotal module within the SAP ERP (Enterprise Resource Planning) system. It assumes the mantle of overseeing every facet of human resource management within an organization. From personnel administration to talent management, SAP HR serves as the linchpin for efficient HR operations."/>           

            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		        <Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`SAP Human Resources (HR) Training is a comprehensive course designed to provide participants with the knowledge and skills to effectively manage human resource processes using the SAP HR module. SAP HR, also known as SAP Human Capital Management (HCM), is a crucial component of the SAP ERP system, dedicated to managing HR functions, employee data, payroll, talent management, and more. This training aims to equip learners with the expertise to configure, customize, and optimize the SAP HR module, ensuring efficient and compliant HR operations within an organization.`} 
            title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our SAP HR course covers human resources management in SAP systems. Topics include personnel administration, organizational management, time management, payroll, and employee self-service. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in SAP HR. By the end of the course, you will be able to implement SAP HR practices in your own projects."}/>
		      </section>
          <Batchtime title={this.props.title} fees="39,999" offer="34,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
 <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo location1={this.props.location1} title={this.props.title}/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
        <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou2="SAP BASIS" coupath2="sap-basis" cou='SAP FICO' coupath='sap-fico' cou9='SAP SD' coupath9='sap-sd' cou6='SAP MM' coupath6='sap-mm' cou10='SAP BI' coupath10='sap-bi'
          cou5='SAP MDG' coupath5='sap-mdg' cou3='SAP FIORI' coupath3='sap-fiori' cou7='SAP ABAP' coupath7='sap-abap'
          cou1='SAP SCM' coupath1='sap-scm' cou8='SAP PP' coupath8='sap-pp'  cou4='SAP S4 HANA' coupath4='sap-s4-hana' />

        
      </>
    );
  }
}
